module.exports = __webpack_public_path__ + "static/media/resume.91ccb92e.pdf";